import { render, staticRenderFns } from "./SfAccordionItem.vue?vue&type=template&id=a9a8cfac&"
import script from "./SfAccordionItem.vue?vue&type=script&lang=js&"
export * from "./SfAccordionItem.vue?vue&type=script&lang=js&"
import style0 from "./SfAccordionItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports